import { createSelector } from 'reselect';

// Config
import { getConfirmedCollectionPointSelector } from '@redux/reducers/click-and-collect/clickAndCollectSelector';
import { getConfigFeaturesSelector } from '@redux/reducers/config/configSelector';
import { isSinglePageCheckoutEnabledFeatureActive } from '@redux/reducers/config/configSelector';
import {
  getConfirmedDeliveryAddressSelector,
  getSelectedDeliveryChoiceIdSelector,
} from '@redux/reducers/delivery/deliverySelector';
import {
  getConfirmationIsClickCollectOrderSelector,
  getConfirmationIsMultiBatchSelector,
  getConfirmationOrderAmountsSelector,
  getConfirmationOrderDeliveriesSelector,
} from '@redux/reducers/confirmation/orderConfirmationSelector';
import {
  getApplyRewardsApiCallActiveSelector,
  getOrderFormAmountsSelector,
  getOrderFormIsClickCollectOrderSelector,
  getOrderFormIsGiftReceiptOrderSelector,
  getOutstandingBalanceExcludingDeliveryChargeRawSelector,
} from '@redux/reducers/order-form/orderFormSelector';
import { isClickAndCollectChoice, isDeliveryChoice } from '@utils/delivery/deliveryHelper';

const getHasSavedFulfilmentDetailsSelector = createSelector(
  [getSelectedDeliveryChoiceIdSelector, getConfirmedDeliveryAddressSelector, getConfirmedCollectionPointSelector],
  (selectedDeliveryChoiceId, confirmedDeliveryAddress, confirmedCollectionPoint) =>
    (isDeliveryChoice(selectedDeliveryChoiceId) && !!confirmedDeliveryAddress) ||
    (isClickAndCollectChoice(selectedDeliveryChoiceId) && !!confirmedCollectionPoint),
);

const orderTotalsOrderFormState = createSelector(
  [
    getOrderFormAmountsSelector,
    getOrderFormIsGiftReceiptOrderSelector,
    getOrderFormIsClickCollectOrderSelector,
    getApplyRewardsApiCallActiveSelector,
    getConfigFeaturesSelector,
    isSinglePageCheckoutEnabledFeatureActive,
    getOutstandingBalanceExcludingDeliveryChargeRawSelector,
    getHasSavedFulfilmentDetailsSelector,
  ],
  (
    amounts,
    isGiftReceiptOrder,
    isClickCollectOrder,
    applyRewardsApiCallActive,
    _configFeatures,
    isSinglePageCheckoutEnabled,
    outstandingBalanceExcludingDeliveryChargeRaw,
    hasSavedFulfilmentDetails,
  ) => ({
    amounts,
    applyRewardsApiCallActive,
    isGiftReceiptOrder,
    isClickCollectOrder,
    isSinglePageCheckoutEnabled,
    outstandingBalanceExcludingDeliveryChargeRaw,
    hasSavedFulfilmentDetails,
  }),
);

const orderTotalsConfirmationPagePropsState = createSelector(
  [
    getConfirmationOrderAmountsSelector,
    getConfirmationIsMultiBatchSelector,
    getConfirmationOrderDeliveriesSelector,
    getConfirmationIsClickCollectOrderSelector,
    getApplyRewardsApiCallActiveSelector,
    getConfigFeaturesSelector,
    isSinglePageCheckoutEnabledFeatureActive,
  ],
  (
    amounts,
    isMultiBatch,
    deliveries,
    isClickCollectOrder,
    applyRewardsApiCallActive,
    _configFeatures,
    isSinglePageCheckoutEnabled,
  ) => ({
    amounts,
    applyRewardsApiCallActive,
    isGiftReceiptOrder: !isMultiBatch && (deliveries?.some((delivery) => delivery.isGiftReceiptOrder) ?? false),
    isClickCollectOrder,
    isSinglePageCheckoutEnabled,
    hasSavedFulfilmentDetails: false,
    outstandingBalanceExcludingDeliveryChargeRaw: undefined,
  }),
);

export { orderTotalsConfirmationPagePropsState, orderTotalsOrderFormState };
